import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import CircularProgress from "@mui/material/CircularProgress";

import COLOR_THEMES from "../../../../colorThemes";
import {Look3DIcon} from "../../../common/icons";
import {FormattedMessage} from "react-intl";
import {featureInterface} from "../../../../interfaces/featureInterface";
import WithShopFeatureVisualizeClick from "./withShopFeatureVisualizeClick";


const ShopFeatureVisualizeButton = (props) => {

  const {activeTheme, feature, bvPresets} = props;

  const hideButton = !feature || !feature.dbFeature || !feature.dbFeature.s3Bindings || !feature.metaData
    || !Array.isArray(feature.metaData["RoomLayout"]) || !feature.metaData["RoomLayout"].length;

  if (hideButton) {
    return null
  }

  const isLoading = !bvPresets.length;
  const isDisabled = !bvPresets.length
    || !bvPresets.find(bvPreset => bvPreset.layout_type === +((feature.metaData["RoomLayout"][0]).replace("Layout", "")));

  return (
    <WithShopFeatureVisualizeClick feature={feature} isDisabled={isDisabled}>
      {(visualizeButtonClick) => (
        <Button className={"look-button look-button--gray look-button--42 look-button--10-radius look-button--no-transform"
          + (isDisabled ? " look-button--disabled" : "")}
                startIcon={isLoading ? <CircularProgress className="grohe-look__button-loader-small"
                                                         style={{'color': COLOR_THEMES[activeTheme].primary}}/> : (
                  <SvgIcon>
                    <Look3DIcon color={COLOR_THEMES[activeTheme].primary} />
                  </SvgIcon>
                )}
                onClick={visualizeButtonClick}>
          <FormattedMessage id="shop.feature.visualize.button"/>
        </Button>
      )}
    </WithShopFeatureVisualizeClick>
  )
};

ShopFeatureVisualizeButton.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {activePreset, bvPresets} = store.bathroomVisualizerState;
  const {visualizersLoaded} = store.serverState;

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    activeTheme,
    activePreset,
    bvPresets,
  };
};

export default connect(mapStateToProps)(ShopFeatureVisualizeButton)
